import { canv } from '@/canv/global.js'

export class shapeRect {

    constructor() {

    }

    drawRoundedRect(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, r);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, r);
        canv.ctx.arcTo(x,   y+h, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+w, y,   r);
        canv.ctx.closePath();
    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - 2 * horizontalPadding;
        var allowedHeight = height - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        this.drawRoundedRect(x, y,  width, height, 0 /*height / 100*/);
    }

    getAvatar(color) {
        return `
        <svg width="60" height="80" viewBox="0 0 60 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="` + color + `" d="M0 0h60v80H0Z" />
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
        <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="24" height="24" fill="` + fill + `" stroke="` + stroke + `"/>
        </svg>
        `;
    }

}
